// Format date with multiple style options
export const formatGameDate = (dateString, format = 'full') => {
  if (!dateString) return '';
  const date = new Date(dateString + 'T00:00:00'); // Add time to avoid timezone issues

  switch (format) {
    case 'full':
      // "Thursday, January 22, 2026"
      return date.toLocaleDateString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });

    case 'no-weekday':
      // "January 22, 2026"
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });

    case 'no-year':
      // "Thursday, January 22"
      return date.toLocaleDateString('en-US', {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
      });

    case 'short':
      // "Jan 22, 2026"
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      });

    case 'short-no-year':
      // "Jan 22"
      return date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
      });

    case 'numeric':
      // "1/22/26"
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const year = date.getFullYear().toString().slice(-2);
      return `${month}/${day}/${year}`;

    case 'numeric-full':
      // "01/22/2026"
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      });

    case 'month-day':
      // "January 22"
      return date.toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
      });

    default:
      return date.toLocaleDateString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
  }
};

// Format time: "6:00 PM"
export const formatGameTime = (timeString) => {
  if (!timeString) return '';
  const [hours, minutes] = timeString.split(':');
  const hour = parseInt(hours);
  const ampm = hour >= 12 ? 'PM' : 'AM';
  const hour12 = hour % 12 || 12;
  return `${hour12}:${minutes} ${ampm}`;
};
